<style lang="scss" scoped="">

  .R {
    word-wrap: break-word;
    word-break: break-all;
  }

  .good-selects {
    .el-select-dropdown__item {
      height: auto;
      width: 300px;
    }
  }

  .align-word {
    letter-spacing: 1em;
    margin-right: -1em;
  }

  .order-list-item {
    cursor: pointer;
  }

  .good-selects {
    .el-select-dropdown__item {
      width: auto;
    }
  }

  .header-list {
    overflow: hidden;
  }
  .content-box {
    max-height: 150px;
    overflow-y: auto;
  }
</style>
<template>
  <div class="order-page">
    <div class="container">
      <div class="opera-btn-group" :class="{up:!showSearch}">
        <div class="opera-icon">
          <!--<span class="">-->
          <!--<i class="el-icon-t-search"></i> 筛选查询-->
          <!--</span>-->
          <span class="pull-left switching-icon" @click="showSearch = !showSearch">
            <i class="el-icon-arrow-up"></i>
            <span v-show="showSearch">收起筛选</span>
            <span v-show="!showSearch">展开筛选</span>
          </span>
        </div>
        <el-form class="advanced-query-form" onsubmit="return false">
          <el-row>
            <el-col :span="10">
              <oms-form-row label="操作人" :span="5">
                <el-select filterable remote placeholder="请输入名称/拼音首字母缩写搜索" :remote-method="filterUser"
                           :clearable="true"
                           v-model="searchWord.operatorUserId" popperClass="good-selects">
                  <el-option :value="user.id" :key="user.id" :label="user.name" v-for="user in userList">
                    <div style="overflow: hidden">
                      <span class="pull-left" style="clear: right">{{user.name}}</span>
                      <span class="pull-right">
                        {{user.companyDepartmentName}}
                      </span>
                    </div>
                  </el-option>
                </el-select>
              </oms-form-row>
            </el-col>
            <el-col :span="10">
              <oms-form-row label="发起时间" :span="5">
                <el-col :span="24">
                  <el-date-picker
                    v-model="expectedTime"
                    type="datetimerange"
                    placeholder="请选择"
                    :default-time="['00:00:00', '23:59:59']">
                  </el-date-picker>
                </el-col>
              </oms-form-row>
            </el-col>
            <el-col :span="4">
              <oms-form-row label="" :span="2">
                <el-button type="primary" native-type="submit" @click="searchInOrder">查询</el-button>
                <el-button native-type="reset" @click="resetSearchForm">重置</el-button>
              </oms-form-row>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <el-table :data="logList" border @row-click="showDetail" class="clearfix" :header-row-class-name="'headerClass'"
                ref="orderDetail" v-loading="loadingData">
        <el-table-column prop="logUuid" label="流水号" :sortable="true" width="200">
        </el-table-column>
        <el-table-column prop="happenTime" label="发起时间" :sortable="true" width="120">
          <template slot-scope="scope">
            {{scope.row.happenTime | time}}
          </template>
        </el-table-column>
        <el-table-column prop="operatorUserName" label="操作人" :sortable="true" width="180"></el-table-column>
        <el-table-column prop="bizType" label="业务类型"  width="100"></el-table-column>
        <el-table-column prop="pushFile" label="推送文件地址" min-width="150">
          <template slot-scope="scope">
            <div class="content-box">
              {{scope.row.pushFile}}
              <des-btn perm="show" @click="downloadFile(scope.row)" icon="download"></des-btn>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="pushCode" label="编号" :sortable="true" width="100"></el-table-column>
        <el-table-column prop="callbackTime" label="回调时间" :sortable="true" width="150">
          <template slot-scope="scope">
            {{scope.row.callbackTime | time}}
          </template>
        </el-table-column>
        <el-table-column prop="callbackResult" label="回调结果" min-width="200">
          <template slot-scope="scope">
            <div class="content-box">{{scope.row.callbackResult}}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="text-center" v-show="(logList.length || pager.currentPage !== 1) && !loadingData">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="pager.currentPage"
                       :page-sizes="[10,20,50,100]" :page-size="pager.pageSize"
                       layout="sizes, prev, pager, next, jumper"
                       :total="pager.count">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import {BaseInfo, User, OrgUser} from '@/resources';
  import methodsMixin from '@/mixins/methodsMinix';
  import {downloadXML} from '@/tools/utils';

  export default {
//    components: {detail},
    mixins: [methodsMixin],
    data() {
      return {
        loadingData: false,
        showSearch: true,
        logList: [],
        filters: {
          operatorUserId: '',
          orgId: '',
          happenStartTime: '',
          happenEndTime: ''
        },
        searchWord: {
          operatorUserId: '',
          orgId: '',
          happenStartTime: '',
          happenEndTime: ''
        },
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: parseInt(window.localStorage.getItem('currentPageSize'), 10) || 10
        },
        expectedTime: '',
        userList: []
      };
    },
    mounted() {
      this.getLogPager(1);
    },
    computed: {},
    watch: {
      filters: {
        handler: function () {
          this.getLogPager(1);
        },
        deep: true
      }
    },
    methods: {
      showActionType: function (item) {
        if (item === 'login') {
          item = '登录';
        }
        return item;
      },
      filterUser: function (query) {
        let orgId = this.$store.state.user.userCompanyAddress;
        let data = Object.assign({}, {
          keyWord: query
        });
        OrgUser.queryOrgInfo(orgId, data).then(res => {
          this.userList = res.data.list;
        });
      },
      handleSizeChange(val) {
        this.pager.pageSize = val;
        window.localStorage.setItem('currentPageSize', val);
        this.getLogPager(1);
      },
      handleCurrentChange(val) {
        this.getLogPager(val);
      },
      filterCustomer: function (query) {// 过滤客户
        BaseInfo.query({keyWord: query, type: 0}).then(res => {
          this.customerList = res.data.list;
        });
      },
      getLogPager: function (pageNo) { // 得到日志列表
        this.pager.currentPage = pageNo;
        let param = Object.assign({}, {
          pageNo: pageNo,
          pageSize: this.pager.pageSize
        }, this.filters);
        this.loadingData = true;
        this.$http.get('/bsp-xtpt/log/org', {params: param}).then(res => {
          this.logList = res.data.list;
          this.pager.count = res.data.count;
          this.loadingData = false;
        });
      },
      showDetail(item) {
        this.currentItemId = item.id;
        this.currentItem = item;
        this.showDetailPart = true;
      },
      resetRightBox() {
        this.showDetailPart = false;
      },
      searchInOrder: function () {// 搜索
        this.searchWord.happenStartTime = this.$formatAryTime(this.expectedTime, 0);
        this.searchWord.happenEndTime = this.$formatAryTime(this.expectedTime, 1);
        Object.assign(this.filters, this.searchWord);
      },
      resetSearchForm: function () {// 重置表单
        this.searchWord = {
          orgId: '',
          operatorUserId: '',
          happenStartTime: '',
          happenEndTime: ''
        };
        this.expectedTime = '';
        Object.assign(this.filters, this.searchWord);
      },
      formatTime(date) {
        return date ? this.$moment(date).format('YYYY-MM-DD') : '';
      },
      downloadFile(date) {
        downloadXML(date.pushFileSignPath, '');
      }
    }
  };
</script>
